// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data-icon',
  template: `
    <div class="no-findings">
      <div>
        <sh-icon [icon]="iconName" size="l" [color]="iconColor"></sh-icon>
      </div>
      <div [innerHtml]="error"></div>
    </div>
  `,
  styleUrls: ['./no-data-icon.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NoDataIconComponent {
  @Input({ required: true }) error?: string;
  @Input({ required: true }) iconName?: string;
  @Input() iconColor: string = '#000000';
}
